// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"546":"c706e438","556":"756319bf","831":"50682b77","868":"2a39b9a3","931":"93dc9355"}[chunkId] + ".chunk.css";
};